import React, { createContext, useState } from 'react';

import { IGridData, IGrid } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CreateGridProvider = <T extends any>() => {
  const GridContext = createContext<IGridData<T>>({} as IGridData<T>);

  const GridProvider = ({ initialState = {}, children }) => {
    const [grid, setGrid] = useState<IGrid<T>>(initialState);
    const onChange = (value: IGrid<T>) =>
      setGrid(currentGrids => ({ ...currentGrids, ...value }));

    return (
      <GridContext.Provider
        value={{
          grid,
          onChange,
        }}
      >
        {children}
      </GridContext.Provider>
    );
  };

  return {
    GridContext,
    GridProvider,
  };
};

export default CreateGridProvider;
